<template>
  <div>
    <list
      ref="refJobLaboralFunctionList"
      sort-by="PuestoFuncionLaboralId"
      :refetch-records="fetchJobLaboralFunctions"
      refetch-records-name="puestosFuncionesLaborales"
      :actions="actions"
      key-field="puestoFuncionLaboralId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteJobLaboralFunction"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refJobLaboralFunctionList = ref(null)
    /* Services */
    const {
      fetchJobLaboralFunctions,
      deleteJobLaboralFunction,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.jobLaboralFunction.columns.job'),
        key: 'puesto.nombre',
      },
      {
        label: i18n.t('humanResources.jobLaboralFunction.columns.laboralFunction'),
        key: 'funcionLaboral.nombre',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'PuestoFuncionLaboral',
        routeName: 'apps-human-resources-job-laboral-function-edit',
        params: ['puestoFuncionLaboralId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'PuestoFuncionLaboral',
        params: ['puestoFuncionLaboralId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-job-laboral-function-add',
        label: i18n.t('Routes.JobLaboralFunctionAdd'),
        aclAction: 'create',
        aclResource: 'PuestoFuncionLaboral',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refJobLaboralFunctionList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchJobLaboralFunctions,
      deleteJobLaboralFunction,
    }
  },
}
</script>
